var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_1493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6853 25.2792C29.5096 25.0333 25.2618 19.25 14.9994 19.25C4.73988 19.25 0.49019 25.0333 0.314408 25.2792C-0.258873 26.0842 -0.0263728 27.1692 0.834252 27.706C1.69488 28.2411 2.85925 28.0241 3.43441 27.2208C3.46722 27.1762 6.72503 22.75 14.9994 22.75C23.1632 22.75 26.4369 27.0498 26.5653 27.2208C26.9277 27.7266 27.5211 28 28.1291 28C28.4844 28 28.8468 27.9042 29.1655 27.706C30.0261 27.1696 30.2605 26.0842 29.6853 25.2792Z",
    fill: "#394240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999 17.5C19.1409 17.5 22.499 14.3675 22.499 10.5V7C22.499 3.1325 19.1409 0 14.999 0C10.8571 0 7.49902 3.1325 7.49902 7V10.5C7.49902 14.3675 10.8571 17.5 14.999 17.5ZM11.249 7C11.249 5.06712 12.93 3.5 14.999 3.5C17.0718 3.5 18.749 5.06712 18.749 7V10.5C18.749 12.4329 17.0718 14 14.999 14C12.93 14 11.249 12.4329 11.249 10.5V7Z",
    fill: "#394240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.249 7C11.249 5.06712 12.93 3.5 14.999 3.5C17.0718 3.5 18.749 5.06712 18.749 7V10.5C18.749 12.4329 17.0718 14 14.999 14C12.93 14 11.249 12.4329 11.249 10.5V7Z",
    fill: "#F9EBB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_1493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManSvgrepoCom);
export default __webpack_public_path__ + "static/media/man-svgrepo-com.b8db0b8c65290b35f02f48cf8462838e.svg";
export { ForwardRef as ReactComponent };